<template>
  <v-app style="background: #ffffff">
    <v-app-bar height="50" v-if="$route.meta.requiresAuth" app dark class="elevation-1 primary">
      <v-toolbar-title>CoryG Media</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-menu right offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon dark v-on="on">
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="logout">
              <v-list-item-icon class="mr-2">
                <v-icon class>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title>logout</v-list-item-title>
            </v-list-item>
            <!-- <v-divider></v-divider>
            <v-list-item>
              <v-list-item-icon class="mr-2">
                <v-icon class>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title>logout</v-list-item-title>
            </v-list-item>-->
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import firebase from "@/firebaseConfig";
export default {
  name: "App",
  data: () => ({}),
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(
          () => {
            this.$router.push("/admin/login");
          },
          err => alert(err.message)
        );
    }
  }
};
</script>
